// ----
// This is where all of the site-specific JS goes. This is the site's main JS file, so make your JS defensive.
// It's created using the JS Module Pattern (http://addyosmani.com/resources/essentialjsdesignpatterns/book/#modulepatternjavascript)
// Usage: SCM.SiteJS.functionName();  Can be used anywhere in the application.
// ----

var SCM = SCM || {};

// ----
// Where all modules get initialized
// ----
// A closure around doc.ready, window.load, window resize, and Ajax Complete so we can safely use $
(function ($, undefined) {

    // Document Ready Event: DOM fully loaded
    $(document).ready(function () {
        if ($('body').hasClass('pg_chapter')) {
            // theme client.script.js file will initialize splitscreen js only for article page. 
            // as we do splitscreen for chapter as well, we are calling init explictly for it.
            SCM.SplitScreen.init();
        }
        SCM.ArticleFulltext.init();

        // this should only be initialized on article page
        if ($('body').hasClass('pg_article')) {
            SCM.InstitutionOpenUrl.init();
        }

        // "Site_Theme_SearchResults" instance name is used in scm.theme.green\SCM.DUP.Web\Themes\Green\app\js\client.solrsearch.js
        // if not all ajax calls on search results page will use "Site_Theme_SearchResults" instead of "SearchResults"
        // below statement will override above value to "SearchResults";

        SCM.SearchResults.defaults.instanceName = 'SearchResults';
    });

    // add border for abstract when necessary
    abstractBorder = function () {
        $(function () {
            if ($('div.kwd-group').length) {
                $('section.trans-abstract p:last-of-type').addClass('abstract-border');
            }
        });
    };

    abstractBorder();

    // submit forgot password from text box with enter key
    submitEmail = function () {
        if ($('#contactEmail').length) {
            $('#contactEmail').keypress(function (e) {
                if (e.which === 13) {
                    $('#forgotPasswordBtn').click();
                }
            });
        };
    };

    submitEmail();

    rightPanelHeight = function () {

        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            setTimeout(
                function () {
                    if ($('.panels').length) {

                        var height = $(window).height();
                        var panelTop = $('.panels').offset().top;
                        var panelHeight = height - panelTop;

                        $('.panels').css('height', panelHeight);
                        $('.dynamic-widget-inner-wrap').addClass('panel-scroll');
                    }
                },
                5000);
        };
    };


    rightPanelHeight();

    bookChapterStandardView = function () {
        if ($('.pg_chapterstandard').length) {
            $('body.pg_chapterstandard').addClass('pg_article');
        }
    };

    bookChapterStandardView();

    adjustArticleMetadataContent = function () {
        var $articleMetadataPanel = $('.article-metadata-panel').last();
        if ($articleMetadataPanel.length === 0) {
            // no abstract, use the standalone metadata panel
            $articleMetadataPanel = $('.article-metadata-standalone-panel');
            // make sure the standalone panel isn't empty before showing
        }

        if ($articleMetadataPanel.length > 0) {
            var $keywordGroupSection = $articleMetadataPanel.find('.kwd-group');
            var $tocSections = $articleMetadataPanel.find('.article-metadata-tocSections');

            if ($keywordGroupSection.length > 0 && $tocSections.length > 0) {
                $articleMetadataPanel.remove('.kwd-group');
                // now append it back
                $articleMetadataPanel.append($keywordGroupSection);
            }
        }
    };
    $(window).on('load', function () {
        adjustArticleMetadataContent();
    });

})(jQuery);